import { createSelector, createSlice } from '@reduxjs/toolkit';
import { WebsiteState } from '../store';

export const { actions, reducer } = createSlice({
    name: 'resources',
    initialState: {} as {
        [key: string]: {
            entries: any[]
        }
    },
    reducers: {}
});

export const selectResources = <TResource>(type: string) => createSelector(
    (state: WebsiteState) => state.resources,
    (resources) => resources[type].entries.map(r => r as TResource));
